// Drawer width budget for all wizard screens - keep in sync with the
// AssociateTenants drawer container (Figma right-side body content is 520px).
export const SIDEBAR_STEP_MAX_WIDTH = '520px';
